import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  addReviewstatus,
  getReviewstatuss,
  getReviewstatus,
  editReviewstatus,
  deleteReviewstatus,
  getAllReviewstatuss,
} from '../../store/actions/reviewstatus_action';
import _debounce from 'lodash/debounce';
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllReviewstatuss = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.reviewstatus);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);

  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteReviewstatus(deleteEntry));
    }
    allQuery();
  }, [deleteEntry]);
  const allQuery = useCallback(
    _debounce(() => {
      dispatch(
        getReviewstatuss({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    if (pageNumber) {
      dispatch(
        getReviewstatuss({
          pageNumber,
        })
      );
    }
  }, [pageNumber]);

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [data, setPageNumber, deleteBtnClicked];
};

// Get Single Data
export const useSingleReviewstatus = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.reviewstatus);
  useEffect(() => {
    dispatch(getReviewstatus(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateReviewstatus = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.reviewstatus);
  const addData = async (data) => {
    await dispatch(addReviewstatus(data));
  };
  return [data, addData];
};
export const useUpdateReviewstatus = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.reviewstatus);
  const updateData = async (id, data) => {
    await dispatch(editReviewstatus(id, data));
  };
  return [updateData];
};

export const useSelectAllReviewstatus = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState('');
  const [value, setValue] = useState('');
  const data = useSelector((state) => state.reviewstatus);
  useEffect(() => {
    dispatch(getAllReviewstatuss({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};

export const useGetDropdownOptions = () => {
  //  const [client, setClientSearchField, setClientSearchValue] =
  // useSelectAllClient();

  const [dropdownOptions, setDropdownOptions] = useState({});
  // useEffect(() => {
  //   if (industry && industry.all_industrys) {
  //     const newData = industry.all_industrys.map((item) => {
  //       return { label: item.name, value: item.name };
  //     });
  //     setDropdownOptions({ ...dropdownOptions, industry: newData });
  //   }
  // }, [industry]);

  return [
    dropdownOptions,
    // setClientSearchField, setClientSearchValue
  ];
};
